import * as styles from './Divide.css';

export interface DivideProps {
  left?: number;
  right?: number;
  top?: number;
  bottom?: number;
  horizontal?: number;
  vertical?: number;
}

const Divide = ({
  left = 0,
  right = 0,
  top = 0,
  bottom = 0,
  horizontal = 0,
  vertical = 0,
}: DivideProps) => {
  return (
    <div
      className={styles.container}
      style={{
        marginTop: top,
        marginLeft: left,
        marginRight: right,
        marginBottom: bottom,
        marginInline: horizontal,
        marginBlock: vertical,
      }}
    />
  );
};

export default Divide;
